/**
 * Clock abstraction for deterministic testing
 * 
 * Usage:
 * - Production: Use clock.now() instead of new Date() or Date.now()
 * - Tests: Call clock.setFixed(date) to freeze time
 */

class Clock {
  private fixedTime: Date | null = null;

  /**
   * Get current time (or fixed time in tests)
   */
  now(): Date {
    return this.fixedTime ? new Date(this.fixedTime) : new Date();
  }

  /**
   * Get current timestamp in milliseconds
   */
  nowMs(): number {
    return this.now().getTime();
  }

  /**
   * Set a fixed time for testing (pass null to restore real time)
   */
  setFixed(date: Date | null): void {
    this.fixedTime = date;
  }

  /**
   * Check if clock is in test mode
   */
  isFixed(): boolean {
    return this.fixedTime !== null;
  }

  /**
   * Advance fixed time by milliseconds (only works in test mode)
   */
  advance(ms: number): void {
    if (!this.fixedTime) {
      throw new Error('Cannot advance time - clock is not in fixed mode');
    }
    this.fixedTime = new Date(this.fixedTime.getTime() + ms);
  }
}

export const clock = new Clock();
